import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledSalesEventCardWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSalesEventHeaderWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      display: flex;
      justify-content: center;
      padding-bottom: ${theme.size.dynamic0100};
      width: 100%;
      height: 100%;
    `;
  }}
`;

export const StyledSalesEventTitleWrapper: any = styled.div`
  display: flex;
  justify-content: center;
`;

export const SalesEventLogoWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      img {
        height: ${theme.size.dynamic0350};
        min-width: ${theme.size.grid012};

        @media (min-width: ${Breakpoints.b960}px) {
          min-width: ${theme.size.grid007}
        }
      }
    `;
  }}
`;

export const StyledOffersWrapper: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 66px ${({ theme }) => theme.size.dynamic0020} 4.2vw;

  @media (max-width: ${Breakpoints.b1280}px) {
    padding-left: ${({ theme }) => theme.size.grid002};
  }
`;

export const StyledGalleryWrapper: any = styled.div`
  ${({ theme }) => `
      align-items: start;
      display: flex;
      justify-content: start;
      width: 100%;

      @media (max-width: ${Breakpoints.b1280}px) {
        background: ${theme.colors.gradient.top};
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom;
        min-height: 100%;
        width: ${theme.size.grid024};
      }

      @media (max-width: ${Breakpoints.b960}px){
        background-size: 100% 70%;
      }

      @media (max-width: ${Breakpoints.b560}px){
        background-size: 100% 80%;
      }

      @media (max-width: 365px){
        background-size: 100% 85%;
      }
  `}
`;

export const StyledLentilsContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      background-color: transparent;
      display: flex;
      justify-content: center;
      width: 100%;
      padding: ${theme.size.dynamic0050};

      & [class^='StyledLentilsContainer-'],
      & [class*=' StyledLentilsContainer-'] {
        background-color: transparent !important;

        button::before {
          background: ${theme.colors.content.inverted};
        }

        @media (max-width: ${Breakpoints.b1280}px) {
          button::before {
            background: rgb(255, 255, 255);
          }
        }
      }
    `
  }}
`;

export const StyledSalesOfferCardWrapper = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      background-size: 100%;
      background: ${theme.colors.gradient.top};
      display: flex;
      justify-content: start;
      min-height: calc((${theme.size.grid012} / 5 * 3) + (2 * ${theme.size.dynamic0150}));
      position: relative;
      min-width: ${theme.size.grid020};
      
      @media (max-width: ${Breakpoints.b1280}px) {
        align-items: start;
        background: none;
        flex-direction: column;
        overflow: hidden;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        min-height: calc((${theme.size.grid013} / 5 * 3) + (2 * ${theme.size.dynamic0150}));
      }
    `;
  }}
`;

export const StyledImageCard = styled.div`
  ${({ theme, imageUrl }) => {
    return `
      align-self: center;
      aspect-ratio: 5/3;
      background: url(${imageUrl}) lightgray 50% / cover no-repeat;
      display: flex;
      justify-content: start;
      min-height: calc(${theme.size.grid020} / 5 * 3);
      min-width: ${theme.size.grid020};
      position: relative;

      @media (min-width: ${Breakpoints.b1280}px) {
        background: url(${imageUrl}) lightgray 50% / cover no-repeat;
        left: calc(-1 * ${theme.size.grid001});
        min-width: ${theme.size.grid012};
        min-height: calc(${theme.size.grid012} / 5 * 3);
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        min-width: ${theme.size.grid013};
        min-height: calc(${theme.size.grid013} / 5 * 3);
      }
    `;
  }
  }
`;

export const StyledOfferInformationWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: start;

  @media (max-width: ${Breakpoints.b1280}px) {
    align-items: start;
  }
`;